module.exports = __webpack_public_path__ + "img/400.df40236e.png";